import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";

const Button = styled.button`
    width: 30px;
    height: 30px;
    background: var(--color-grey200);
    border-radius: 5px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;

    i{
      color: var(--color-grey900) !important;
    }
`;

const prependRoot = url =>
  url.startsWith('/') ? url : '/' + url;

export const BackButton = ({className, style, returnUrl}) => {
const navigate = useNavigate();
return (
  <Button
    className={className} style={style}
    onClick={() => returnUrl ? navigate(prependRoot(returnUrl)): navigate(-1)}
  >
    <i className="material-icons">keyboard_arrow_left</i>
  </Button>
);
}

